import { Component, OnDestroy } from '@angular/core';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../.././models/Constants';


@Component({
  selector: 'app-case-management-card',
  templateUrl: './case-management-card.component.html',
  styleUrls: ['./case-management-card.component.scss'],
})
export class CaseManagementCardComponent implements OnDestroy {
  // caseManagements: CaseManagement[] = [];
  // dbCaseManagementLoader: boolean = false;
  // showLoaderMsg: boolean = false;
  // loaderTimeoutId: any;
  // isCaseManagementErrorEnabled: boolean = false;

  public iconConfig = {
    iconName: 'arrow-right',
    iconType: 'light',
    iconPlacement: 'right',
  };
  
  loaderType = Constants.LOADER_TYPE.CARD;
  constructor(
    public rootScopeService: RootScopeService
  ) { }



  // /*getCaseManagementsDetails method is fetching the data of CaseManagements(linkLable & uri of Case Managements) by hitting the backend Service.**/
  // getCaseManagementsDetails() {
  //   this.startTimerForLoader();
  //   this.isCaseManagementErrorEnabled = false;
  //   this.dbCaseManagementLoader = true;
  //   this.dashboardService.getCaseManagementDetails().subscribe({
  //     next: (res: CaseManagement[]) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.dbCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       this.caseManagements = res;
  //     },
  //     error: (error) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.dbCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       this.isCaseManagementErrorEnabled = true;
  //     },
  //     complete: () => { },
  //   });
  // }

  /*goToCaseManagement method open SSOLink in new TAB*/
  // goToCaseManagement(uri: string) {
  //   this.startTimerForLoader();
  //   this.isCaseManagementErrorEnabled = false;
  //   this.dbCaseManagementLoader = true;
  //   let model = {
  //     clientId: this.rootScopeService.dashboardForm.get('clientId')?.value,
  //     linkId: "HRX-SSO-DASHBOARD",
  //   };
  //   this.dashboardService.getSSOLink(uri?.includes('linkType=HFIM')?'/api/link/getLinkUrl':uri, model).subscribe({
  //     next: (res) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.dbCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       let winUrl = URL.createObjectURL(
  //         new Blob([res], { type: 'text/html' })
  //       );
  //       this.rootScopeService.openNewTab(winUrl);
  //     },
  //     error: (error) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.dbCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       this.isCaseManagementErrorEnabled = true;
  //     },
  //     complete: () => { },
  //   });
  // }


  // startTimerForLoader() {
  //   this.loaderTimeoutId = setTimeout(() => {
  //     this.showLoaderMsg = true;
  //   }, 1 * this.rootScopeService.showLoaderMsgThreshold * 1000);
  // }

  goToCaseManagement(selectedLink) {
    // console.log(selectedLink);
    this.rootScopeService.isDbCaseManagementErrorEnabled = false;
    this.rootScopeService.hasNoDbCaseManagementData = false;
    if (selectedLink && selectedLink?.actionCode == "LINK_ACTION") {
      this.rootScopeService.selectedLeftNavBarLink(selectedLink, false);
    } else {
      //  console.log('action code is not link action');
      this.rootScopeService.isDbCaseManagementErrorEnabled = true;
    }
  }


  closeWarning() {
    this.rootScopeService.isDbCaseManagementErrorEnabled = false;
    this.rootScopeService.hasNoDbCaseManagementData = false;
  }


  ngOnDestroy() {
    clearTimeout(this.rootScopeService.dbMyTodoloaderTimeoutId);
  }
}
